/** Карточка сотрудника, как её отдаёт GET /employees/:id. */
export interface EmployeeDetail {
  id: number;
  personnelNumber: string;
  lastName: string;
  firstName: string;
  middleName: string | null;
  phone: string | null;
  email: string | null;
  photoKey: string | null;
  workSchedule: string | null;
  hireDate: string | null;
  dismissDate: string | null;
  isActive: boolean;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  departmentId: number | null;
  department: { id: number; name: string } | null;
  positionId: number | null;
  position: { id: number; name: string; requiresDriverLicense: boolean } | null;
  userId: number | null;
  driverProfile: { id: number } | null;
  // Личные данные — приходят только с правом employee.sensitive_read.
  birthDate?: string | null;
  hireOrderNumber?: string | null;
  dismissOrderNumber?: string | null;
  address?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  permits: Array<{
    id: number;
    documentNumber: string | null;
    issuedAt: string;
    expiresAt: string;
    permitType: { id: number; name: string };
  }>;
  documents: Array<{
    id: number;
    documentNumber: string | null;
    issuedCountry: string | null;
    issuedBy: string | null;
    issuedAt: string | null;
    expiresAt: string | null;
    notes: string | null;
    documentType: { id: number; name: string };
  }>;
}

export const fullNameOf = (e: Pick<EmployeeDetail, 'lastName' | 'firstName' | 'middleName'>): string =>
  `${e.lastName} ${e.firstName} ${e.middleName ?? ''}`.trim();

/** Ключ запроса карточки — общий для всех разделов, чтобы одна правка обновляла всё. */
export const employeeKey = (id: number): unknown[] => ['employee', id];
